var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Glide from '@glidejs/glide';
import ProductItem from './ProductItem';
var ProductItemSlider = /** @class */ (function (_super) {
    __extends(ProductItemSlider, _super);
    function ProductItemSlider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductItemSlider.prototype.componentDidMount = function () {
        new Glide('.glide-product', { gap: 20 }).mount();
    };
    ProductItemSlider.prototype.render = function () {
        return (React.createElement("div", { className: "c-product-item-slider" },
            React.createElement("div", { className: "glide-product" },
                React.createElement("div", { className: "glide__track", "data-glide-el": "track" },
                    React.createElement("ul", { className: "glide__slides" }, this.props.items.map(function (itemId, key) { return (React.createElement("li", { className: "glide__slide", key: key },
                        React.createElement(ProductItem, { itemId: itemId, modifier: "h250" }))); }))))));
    };
    return ProductItemSlider;
}(React.Component));
export default ProductItemSlider;
